import moment from "moment";
import "moment/locale/sv";

moment.locale("sv");
moment.relativeTimeThreshold("m", 60);

moment.duration.fn.format = function (input) {
  var output = input;
  var milliseconds = this.asMilliseconds();
  var totalMilliseconds = 0;
  var replaceRegexps = {
    years: /Y(?!Y)/g,
    months: /M(?!M)/g,
    weeks: /W(?!W)/g,
    days: /D(?!D)/g,
    hours: /H(?!H)/g,
    minutes: /m(?!m)/g,
    seconds: /s(?!s)/g,
    milliseconds: /S(?!S)/g,
  };
  var matchRegexps = {
    years: /Y/g,
    months: /M/g,
    weeks: /W/g,
    days: /D/g,
    hours: /H/g,
    minutes: /m/g,
    seconds: /s/g,
    milliseconds: /S/g,
  };
  for (var r in replaceRegexps) {
    if (replaceRegexps[r].test(output)) {
      var as = "as" + r.charAt(0).toUpperCase() + r.slice(1);
      var value = Math.floor(
        moment.duration(milliseconds - totalMilliseconds)[as]()
      );
      var replacements = output.match(matchRegexps[r]).length - value.length;
      output = output.replace(replaceRegexps[r], value);

      while (replacements > 0 && replaceRegexps[r].test(output)) {
        output = output.replace(replaceRegexps[r], "0");
        replacements--;
      }
      output = output.replace(matchRegexps[r], "");

      var temp = {};
      temp[r] = parseInt(value, 10);
      totalMilliseconds += moment.duration(temp).asMilliseconds();
    }
  }
  return output;
};

export const handleError = (err) => {
  console.log("Error!", err);
};

const today = (locale) => {
  return moment().locale(locale);
};

export function compactTime(date, locale, language) {
  if (!date) return "-";

  if (!date.isSame) date = moment(date).locale(locale);

  const td = today(locale);
  const tomorrow = today(locale).add(1, "days");
  const nextWeek = today(locale).add(6, "days");

  if (date.isSame(td, "day")) return `${language.today} ` + date.format("LT");

  if (date.isSame(tomorrow, "day"))
    return `${language.tomorrow} ` + date.format("LT");

  if (date.isBefore(nextWeek)) {
    if (locale === "en") {
      return `${date.locale(locale).format("dddd")} ${date
        .locale(locale)
        .format("LT")}`;
    }
    return date.locale(locale).format("dddd HH:mm");
  }

  return date.locale(locale).format("llll");
}

export function compactDate(date, locale, language) {
  if (!date) return "-";

  if (!date.isSame) date = moment(date).locale(locale);

  const td = today(locale);
  const yesterday = today(locale).add(-1, "days");
  const tomorrow = today(locale).add(1, "days");

  if (date.isSame(yesterday, "day")) return language.yesterday;

  if (date.isSame(td, "day")) return language.today;

  if (date.isSame(tomorrow, "day")) return language.tomorrow;

  return date.locale(locale).format("LL");
}

export function randomString(len, charSet) {
  charSet = charSet || "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var randomString = "";
  for (var i = 0; i < len; i++) {
    var randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }
  return randomString;
}

export function stringJoin(values, separator = ", ") {
  let result = "";
  const last = values.length - 1;

  for (let i = 0; i < values.length; i++) {
    result += values[i];

    if (i !== last) {
      result += separator;
    }
  }

  return result;
}

export function weekdayName(day) {
  switch (day) {
    case 0:
      return "Måndag";
    case 1:
      return "Tisdag";
    case 2:
      return "Onsdag";
    case 3:
      return "Torsdag";
    case 4:
      return "Fredag";
    case 5:
      return "Lördag";
    case 6:
      return "Söndag";
    default:
      return "????";
  }
}

export function currentWeek() {
  return weekOf(new Date());
}

// Returns the ISO week of the date.
export function weekOf(date) {
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  var week =
    1 +
    Math.round(
      ((date.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7
    );

  var year = date.getFullYear();

  return {
    week,
    year,
  };
}

//5 minute resolution
export const roundTime = (t) => {
  let m = moment(t);
  const minute = m.minute();

  const rounded = 5 * Math.round(minute / 5);

  m.minute(rounded);

  return m.toDate();
};

export function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}
